import { persistedExchange } from "@urql/exchange-persisted";
import type { TypedDocumentNode } from "@urql/core";

/**
 * Creates the persisted queries exchange using build-time hashes.
 *
 * @graphql-codegen/client-preset embeds a __meta__.hash on each document
 * node at codegen time. This exchange reads that hash instead of computing
 * SHA-256 at runtime, ensuring the frontend hash always matches the
 * persisted-documents.json manifest loaded by the API.
 *
 * If the server returns PersistedQueryNotFound (e.g. manifest mismatch
 * during development), the exchange retries with the full query body.
 *
 * GET vs POST is NOT controlled here — the cache classification exchange
 * sets `context.preferGetMethod` only on cacheable queries.
 */
export function createApqExchange() {
  return persistedExchange({
    preferGetForPersistedQueries: false,
    enforcePersistedQueries: false,
    generateHash: (_query: string, document: TypedDocumentNode) => {
      // Read the codegen-embedded hash from __meta__
      const meta = (document as unknown as { __meta__?: { hash?: string } })
        ?.__meta__;
      if (meta?.hash) {
        return Promise.resolve(meta.hash);
      }
      // Fallback: should not happen if codegen ran correctly
      // Return empty string to let the exchange skip persisted mode
      return Promise.resolve("");
    },
  });
}
